import * as React from 'react';
import useUpdateRef from '../../../../hooks/useUpdateRef';
import { useDebounceCallback } from '../../../../hooks/code/useDebounce';
import Dropdown from '../../Dropdown/Dropdown';
import Input from '../../Input/Input';
import { AddFilterDropdown } from '../AddFilter/AddFilter';
import type { FilterItem, StringFilterItem } from '../../../../types/Filter';
import type { OnFilterChangeHandler } from '../types';
import DeleteFilterButton from './DeleteFilterButton';
import Styles from './filter-views.module.scss';

type Props = {
    filterItem: StringFilterItem;
    availableFilters: FilterItem[];
    onChange: OnFilterChangeHandler;
};

const DROPDOWN_ITEMS = [
    { name: 'Contains', value: 'includes' },
    { name: 'Does not contain', value: 'not-includes' },
    { name: 'Equals', value: 'eq' },
    { name: 'Does not equal', value: 'neq' }
];

const StringFilterView = (props: Props) => {
    const { filterItem } = props;
    const onChangeRef = useUpdateRef(props.onChange);

    const [value, setValue] = React.useState(filterItem.value);
    React.useEffect(() => {
        setValue(filterItem.value);
    }, [filterItem.value]);

    const changeValue = useDebounceCallback(
        () => {
            if (value !== filterItem.value) {
                onChangeRef.current?.({
                    ...filterItem,
                    value
                });
            }
        },
        { delay: 500, changes: [value, filterItem] }
    );

    const selectedOperatorItem = DROPDOWN_ITEMS.find((item) => item.value === filterItem.operator);

    return (
        <div className={Styles['filter-view']}>
            <AddFilterDropdown
                availableFilters={props.availableFilters}
                value={filterItem}
                onAdd={(filterItem) => filterItem !== props.filterItem && props.onChange(filterItem)}
            />
            <Dropdown
                options={DROPDOWN_ITEMS}
                value={filterItem.operator}
                className={Styles.control}
                menuClassName={Styles['filter-view-dropdown-tooltip']}
                onChange={(operator) => {
                    changeValue.cancel();
                    if (operator !== filterItem.operator) {
                        props.onChange({
                            ...filterItem,
                            operator: operator as StringFilterItem['operator']
                        });
                    }
                }}
                dataTip={selectedOperatorItem?.name}
                dataTipOverflow
            />
            <Input
                placeholder="Enter string"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                    changeValue();
                }}
                onBlur={() => {
                    changeValue.flush();
                }}
            />
            <DeleteFilterButton {...props} />
        </div>
    );
};

export default StringFilterView;
